import * as Sentry from '@sentry/browser';

interface InitSentryOptions {
    environment?: string;
    release?: string;
    dsn?: string;
    project: string;
    poolInstance?: string;
}

export const initSentry = (options: InitSentryOptions) => {
    if (!options.dsn) {
        return;
    }

    const { project, poolInstance, ...sentryBrowserOptions } = options;

    Sentry.init({
        ...sentryBrowserOptions,
        ignoreErrors: [
            'Network Error',
            'SecurityError: The operation is insecure.',
            'Request aborted',
            'Request failed with status code 502',
        ],
    });

    Sentry.configureScope(scope => {
        scope.setTag('project', project);

        if (poolInstance) {
            scope.setTag('pool_instance', poolInstance);
        }
    });
};

export const sentrySetUser = Sentry.setUser;
